import { render } from "./FrontDeskForm.vue?vue&type=template&id=1cafb5e8"
import script from "./FrontDeskForm.vue?vue&type=script&lang=js"
export * from "./FrontDeskForm.vue?vue&type=script&lang=js"

import "./FrontDeskForm.vue?vue&type=style&index=0&id=1cafb5e8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__